import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import { canView, historyPath } from '../../modules/utils';
import "./navbar.css"
import i18next from "i18next";
import { setLanguage } from "../../actions";
import { AppBar, Toolbar, Box, Container, IconButton, Typography, Tooltip, Avatar, Menu, MenuItem, ListItemIcon } from '@mui/material';

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: state.language,
        company_layout: state.company_layout,
        company: state.company
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLanguage: (lang) => dispatch(setLanguage(lang))
    }
}

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorElNav: null
        };
    }
    logout() {
        window.firebase.auth().signOut();
    }
    handleLanguage = async (l) => {
        this.props.setLanguage(l)
    }

    handleOpenNavMenu = (event) => {
        this.setState({ anchorElNav: event.currentTarget });
    };

    handleCloseNavMenu = () => {
        this.setState({ anchorElNav: null });
    };

    render() {
        const { company_layout, language, history, location } = this.props;
        const logoUrl = company_layout.hasOwnProperty('logo') ? company_layout.logo.url : "../../img/logo_neg.png";
        const logoBackground = (company_layout.hasOwnProperty('logo') && company_layout.logo.hasOwnProperty('background')) ? company_layout.logo.background : "var(--color-secondary)";

        // Navigation items definition to keep render clean
        const navItems = [
            { path: '/giri-cdi', label: 'giri', icon: 'fa-bus', permission: 'giri_cdi' },
            { path: '/cdi-absences', label: 'assenze', icon: 'fa-user-slash', permission: 'cdi_absences' },
            { path: '/prenotazione', label: 'prenota', icon: 'fa-calendar-days', permission: 'Prenotazione' },
            { path: historyPath(this.props.company), label: 'storico', icon: 'fa-route', permission: null }, // Permission null means always visible (or handled elsewhere if needed, but existing code had no check)
            /* { path: '/assenze', label: 'assenze', icon: 'fa-calendar-times', permission: 'Assenze' }, */
            { path: '/mappa', label: 'mappa', icon: 'fa-map', permission: 'Mappa' },
            { path: '/utenti', label: 'utenti', icon: 'fa-users', permission: 'Utenti' }
        ];

        return (
            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%)',
                    borderBottom: 'none',
                    color: '#fff',
                    py: 1,
                    borderRadius: 0,
                    boxShadow: 'none'
                }}
            >
                <Container maxWidth="xl">
                    <Toolbar disableGutters sx={{ justifyContent: 'space-between', minHeight: '70px !important' }}>

                        {/* Logo Section */}
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box
                                sx={{
                                    height: 48,
                                    px: 3,
                                    bgcolor: logoBackground,
                                    borderRadius: 50,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
                                }}
                            >
                                <img src={logoUrl} alt="Logo" style={{ maxHeight: '32px', maxWidth: '140px', objectFit: 'contain' }} />
                            </Box>
                        </Box>

                        {/* Navigation Links - Desktop */}
                        <Box sx={{
                            display: { xs: 'none', md: 'flex' },
                            gap: 0.5,
                            bgcolor: 'rgba(0,0,0,0.18)',
                            p: 0.75,
                            borderRadius: 10,
                            border: '1px solid rgba(255,255,255,0.12)',
                        }}>
                            {navItems.map((item) => {
                                if (item.permission && !canView(item.permission)) return null;
                                const isActive = location.pathname.startsWith(item.path);
                                return (
                                    <Link key={item.path} to={item.path} style={{ textDecoration: 'none' }}>
                                        <Box
                                            sx={{
                                                px: 2.5,
                                                py: 1,
                                                borderRadius: 8,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                transition: 'all 0.2s ease',
                                                position: 'relative',
                                                bgcolor: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
                                                color: isActive ? '#fff' : 'rgba(255,255,255,0.7)',
                                                fontWeight: isActive ? 700 : 600,
                                                '&::after': isActive ? {
                                                    content: '""',
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    width: '60%',
                                                    height: '3px',
                                                    bgcolor: 'var(--color-warning)',
                                                    borderRadius: '3px 3px 0 0',
                                                } : {},
                                                '&:hover': {
                                                    bgcolor: 'rgba(255,255,255,0.1)',
                                                    color: '#fff'
                                                }
                                            }}
                                        >
                                            <i className={`fa-solid ${item.icon}`} style={{ fontSize: 15 }}></i>
                                            <Typography sx={{ fontWeight: 'inherit', fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                {i18next.t(item.label)}
                                            </Typography>
                                        </Box>
                                    </Link>
                                );
                            })}
                        </Box>

                        {/* Navigation Menu - Mobile */}
                        <Box sx={{
                            display: { xs: 'flex', md: 'none' },
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'rgba(255,255,255,0.15)',
                            borderRadius: '50%',
                            width: 44,
                            height: 44,
                        }}>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={this.handleOpenNavMenu}
                                sx={{ color: '#fff' }}
                            >
                                <i className="fa-solid fa-bars"></i>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={this.state.anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(this.state.anchorElNav)}
                                onClose={this.handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                    '& .MuiPaper-root': {
                                        borderRadius: 4,
                                        marginTop: 1,
                                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                                    }
                                }}
                            >
                                {navItems.map((item) => {
                                    if (item.permission && !canView(item.permission)) return null;
                                    const isActive = location.pathname.startsWith(item.path);
                                    return (
                                        <MenuItem
                                            key={item.path}
                                            onClick={() => {
                                                this.handleCloseNavMenu();
                                                history.push(item.path);
                                            }}
                                            sx={{
                                                gap: 2,
                                                color: isActive ? 'var(--color-primary)' : '#64748b',
                                                bgcolor: isActive ? '#f1f5f9' : 'transparent',
                                                '&:hover': {
                                                    bgcolor: '#f1f5f9',
                                                    color: 'var(--color-primary)'
                                                }
                                            }}
                                        >
                                            <ListItemIcon sx={{ minWidth: 30, color: 'inherit' }}>
                                                <i className={`fa-solid ${item.icon}`} style={{ fontSize: 18 }}></i>
                                            </ListItemIcon>
                                            <Typography textAlign="center" sx={{ fontWeight: 600 }}>{i18next.t(item.label)}</Typography>
                                        </MenuItem>
                                    )
                                })}
                            </Menu>
                        </Box>

                        {/* Right Actions */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                bgcolor: 'rgba(0,0,0,0.18)',
                                borderRadius: 50,
                                px: 1,
                                py: 0.75,
                                border: '1px solid rgba(255,255,255,0.12)',
                            }}
                        >
                            <Tooltip title={i18next.t("options")}>
                                <IconButton
                                    onClick={() => history.push('/options')}
                                    sx={{
                                        width: 38,
                                        height: 38,
                                        color: 'rgba(255,255,255,0.8)',
                                        '&:hover': { bgcolor: 'rgba(255,255,255,0.12)', color: '#fff' }
                                    }}
                                >
                                    <i className="fa fa-cog" style={{ fontSize: 17 }}></i>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title={language === 'it' ? i18next.t("italiano") : i18next.t("inglese")}>
                                <IconButton
                                    onClick={() => this.handleLanguage(language === 'it' ? 'en' : 'it')}
                                    sx={{
                                        width: 38,
                                        height: 38,
                                        p: 0,
                                        '&:hover': { bgcolor: 'rgba(255,255,255,0.12)' }
                                    }}
                                >
                                    <Avatar
                                        src={`/img/${language}.svg`}
                                        sx={{ width: 22, height: 22, borderRadius: 0 }}
                                    />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title={i18next.t("logout")}>
                                <IconButton
                                    onClick={() => this.logout()}
                                    sx={{
                                        width: 38,
                                        height: 38,
                                        color: 'rgba(255,255,255,0.7)',
                                        '&:hover': { bgcolor: 'rgba(220,53,69,0.3)', color: '#ff6b6b' }
                                    }}
                                >
                                    <i className="fa-solid fa-arrow-right-from-bracket" style={{ fontSize: 16 }}></i>
                                </IconButton>
                            </Tooltip>
                        </Box>

                    </Toolbar>
                </Container>
            </AppBar>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));